import React from "react";
import "./styles/tokens.css";
import "./styles/global.css";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = createRoot(document.getElementById("root"));
root.render(<App />);

requestAnimationFrame(() => {
  document.documentElement.classList.add("app-ready");
});

reportWebVitals();